// extracted by mini-css-extract-plugin
export default {"calendarLayout":"WallCalendar_calendarLayout__actD6","gridColumn":"WallCalendar_gridColumn__o28NS"};